import React from 'react';
import PropTypes from 'prop-types';
import HeadlineContainer from '../headline/headlineContainer';
import RatingsAndReviews from '../ratingsAndReviews/ratingsAndReviewsContainer';
import DeliveryAccordionContainer from '../deliveryAccordion/deliveryAccordionContainer';

const GeneralInfo = ({
  name,
  description,
  price,
  wasPrice,
  markdown,
  technologyGroup,
  heroBadgeElements,
  promoBadgeElements,
}) => {
  return (
    <div className="pdp-form__title">
      <h1 className="pdp-form__title-product-name-wrapper">
        <span className="pdp-form__title-product-title" dangerouslySetInnerHTML={{ __html: name }} />
        &nbsp;
        <span className="pdp-form__title-subtitle" dangerouslySetInnerHTML={{ __html: description }} />
      </h1>
      <div className="pdp-form__title-product-price-rating-wrapper">
        {markdown ? (
          <div>
            <span className="pdp-form__title-was-price">{wasPrice}</span>
            <span className="pdp-form__title-price _is-price-reduced">{price}</span>
          </div>
        ) : (
          <span className="pdp-form__title-price">{price}</span>
        )}
        <RatingsAndReviews />
        <DeliveryAccordionContainer />
      </div>
      {promoBadgeElements.length > 0 && <div className="product-badge__promo-wrapper">{promoBadgeElements}</div>}
      <HeadlineContainer />
      {(heroBadgeElements.length > 0 || technologyGroup) && (
        <div className="product-badge__hero-wrapper">
          {heroBadgeElements} <span>{technologyGroup}</span>
        </div>
      )}
    </div>
  );
};

GeneralInfo.propTypes = {
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  wasPrice: PropTypes.string.isRequired,
  markdown: PropTypes.bool.isRequired,
  heroBadgeElements: PropTypes.node.isRequired,
  promoBadgeElements: PropTypes.node.isRequired,
};

export default GeneralInfo;
